exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-title {\n  font-weight: bold;\n  color: #326792; }\n\n.panel {\n  border: none;\n  border-radius: 0px;\n  border-top: #326792 3px solid; }\n\n.issues-text {\n  float: left;\n  color: #326792;\n  font-weight: bold;\n  margin-bottom: 20px; }\n\n.issues-tag {\n  float: left;\n  margin-left: 20px;\n  background-color: red;\n  width: 40px;\n  color: white;\n  text-align: center;\n  border-radius: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/common/issues-graph-widget/issues-graph-widget.component.scss
// module id = 1109
// module chunks = 7